/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./privacy-data-box.vue.js?vue&type=template&id=0cd9a5f8!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./privacy-data-box.vue?vue&type=template&id=0cd9a5f8"
import script from "./privacy-data-box.vue.ts?vue&type=script&lang=ts&setup=true!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./privacy-data-box.vue?vue&type=script&lang=ts&setup=true"
export * from "./privacy-data-box.vue.ts?vue&type=script&lang=ts&setup=true!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./privacy-data-box.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./privacy-data-box.vue.postcss?vue&type=style&index=0&id=0cd9a5f8&prod&lang=postcss!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./privacy-data-box.vue?vue&type=style&index=0&id=0cd9a5f8&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports